<template>
  <BasePageContainer class="pt-10">
    <PageHeader
      has-back
      with-members>
      身長体重管理
    </PageHeader>
    <BodyMeasurementsForm
      ref="form"
      @submit="onSubmit" />
  </BasePageContainer>
</template>

<script>
import BasePageContainer from '@/components/parts/BasePageContainer.vue'
import PageHeader from '@/components/parts/PageHeader.vue'
import BodyMeasurementsForm from '@/components/view/profile/body_measurements/BodyMeasurementsForm.vue'
import confirmIfFormChanged from '@/components/mixin/confirmIfFormChanged'
export default {
  components: {
    BasePageContainer,
    PageHeader,
    BodyMeasurementsForm
  },
  mixins: [confirmIfFormChanged()],
  methods: {
    onSubmit(formData) {
      return this.postBodyMeasurements(formData).then(() => {
        this.$store.commit('notify/set', {message: '身長体重を登録しました'})
        this.canLeave = true
        this.$nextTick(() => {
          this.$router.push(`/members/${this.$route.params.id}/profile`, { replace: true })
        })
      })
    },
    postBodyMeasurements(formData) {
      return this.$axios.post('/profiles/body-measurements/', formData)
    }
  }
}
</script>

<style>

</style>